import * as React from 'react';
import {
  Provider, useDispatch, useSelector,
} from 'react-redux';
import { isUndefined, isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';
import useInterval from './utils/useInterval';
import store from './redux/init';
import OrderMap from './components/OrderMap';
import BottomSheet from './components/BottomSheet';
import { load as loadOrder } from './redux/order/actions';

const ShowSpinner = () => (
  <div className="loading">
    <img
      className="loading__logo"
      alt="Meridian Taxi"
      src="/assets/logo-taxi.png"
    />
    <div className="loading__bar" role="progressbar" aria-label="Loading" />
  </div>
);

const NoOrder = () => (
  <div className="noOrder">
    <img className="noOrder__logo" alt="Meridian Taxi" src="/assets/logo-taxi.png" />
    <h1 className="noOrder__title">
      <FormattedMessage id="no_order_title" />
    </h1>
    <p className="noOrder__text">
      <FormattedMessage id="no_order_text" />
    </p>
    <a href="https://bit.ly/TaxiMer" target="_blank" rel="noreferrer" className="installButton">
      <FormattedMessage id="install_meridian" />
    </a>
  </div>
);

function App(): JSX.Element {
  const dispatch = useDispatch();
  const idHash = window.location.pathname.replace('/', '');

  const order = useSelector((state: CR.RootState) => state.order);

  React.useEffect(() => {
    if (idHash) {
      dispatch(loadOrder({ id: idHash }));
    }
  }, [dispatch, idHash]);

  useInterval(
    () => {
      dispatch(loadOrder({ id: idHash }));
    }, idHash && isEmpty(order.error) ? parseInt(process.env.REACT_APP_GETORDER as string, 10) : null,
  );

  return (
    <>
      {order.loading && isUndefined(order.order)
        ? <ShowSpinner />
        : (
          <>
            {!isUndefined(order.order)
              ? (
                <>
                  <OrderMap />
                  <BottomSheet />
                </>
              )
              : <NoOrder />}
          </>
        )}
    </>
  );
}

const WrappedApp = (): JSX.Element => (
  <Provider store={store}>
    <App />
  </Provider>
);

export default WrappedApp;
